import { node, string, bool } from 'prop-types';
import styled from 'styled-components';

import { GREY_COLOR, DESKTOP_SIZE } from '../../constants';

const Container = styled.div`
  color: ${({ color }) => (color ? color : GREY_COLOR)};
  display: ${({ isInline }) => isInline && 'inline'};
  font-size: ${({ size }) => size};
  font-weight: ${({ isBold }) => (isBold ? 500 : 400)};
  margin: ${({ margin }) => (margin ? margin : 'initial')};
  text-align: ${({ textAlign }) => (textAlign ? textAlign : null)};
  transition: color 150ms linear;
  justify-content: ${({ justifyContent }) =>
    justifyContent ? justifyContent : null};
  @media (max-width: ${DESKTOP_SIZE}) {
    font-size: ${({ fontSizeMobile }) => fontSizeMobile};
  }
`;

const StyledText = ({
  children,
  size,
  color,
  margin,
  isBold,
  isInline,
  padding,
  textAlign,
  className,
  fontSizeMobile,
}) => (
  <Container
    size={size}
    color={color}
    margin={margin}
    isBold={isBold}
    isInline={isInline}
    padding={padding}
    textAlign={textAlign}
    className={className}
    fontSizeMobile={fontSizeMobile}
  >
    {children}
  </Container>
);

StyledText.propTypes = {
  children: node.isRequired,
  color: string,
  isBold: bool,
  isInline: bool,
  padding: string,
  size: string,
  fontSizeMobile: string,
  margin: string,
  textAlign: string,
  className: string,
};

export default StyledText;



// WEBPACK FOOTER //
// components/shared/StyledText.js